module.exports = __webpack_public_path__ + "img/45_28.a08f46da.png";